import React, { useState, useEffect } from 'react';
import squarespaceRSS from '../utils/squarespaceRss';

const SquarespaceTest = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [siteInfo, setSiteInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Test RSS blog posts
        const posts = await squarespaceRSS.getBlogPosts(5);
        setBlogPosts(posts);
        
        // Test site info
        const info = await squarespaceRSS.getSiteInfo();
        setSiteInfo(info);
        
        console.log('RSS Blog Posts:', posts);
        console.log('Site Info:', info);
        
      } catch (err) {
        setError(err.message);
        console.error('RSS Test Error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return <div className="loading-container">Testing Squarespace RSS feed...</div>;
  }

  if (error) {
    return (
      <div style={{ padding: '2rem', color: 'red' }}>
        <h3>RSS Error:</h3>
        <p>{error}</p>
        <p>Check console for more details.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto' }}>
      <h2>Squarespace RSS Test Results</h2>
      
      <div style={{ marginBottom: '2rem' }}>
        <h3>Site Information</h3>
        {siteInfo && (
          <div style={{ 
            border: '1px solid #ddd', 
            padding: '1rem', 
            marginBottom: '1rem',
            borderRadius: '8px'
          }}>
            <h4>Title: {siteInfo.title}</h4>
            <p><strong>Description:</strong> {siteInfo.description}</p>
            <p><strong>Link:</strong> {siteInfo.link}</p>
          </div>
        )}
      </div>
      
      <div style={{ marginBottom: '2rem' }}>
        <h3>Blog Posts ({blogPosts.length})</h3>
        {blogPosts.map((post, index) => (
          <div key={index} style={{ 
            border: '1px solid #ddd', 
            padding: '1rem', 
            marginBottom: '1rem',
            borderRadius: '8px'
          }}>
            <h4>{post.title}</h4>
            <p><strong>Author:</strong> {post.author}</p>
            <p><strong>Date:</strong> {post.date}</p>
            <p><strong>Category:</strong> {post.categoryName}</p>
            <p><strong>Excerpt:</strong> {post.excerpt}</p>
            {post.image && (
              <img 
                src={post.image} 
                alt={post.title}
                style={{ maxWidth: '200px', height: 'auto', marginTop: '0.5rem' }}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SquarespaceTest; 